import ReleaseNotesDialog from './ReleaseNotesDialog';

export default ReleaseNotesDialog;
